import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { chain, filter, find, map, some } from 'lodash';
import { useInteractionState, useTranslation } from '@/hooks';
import { Category, Order, Product } from '@/type';
import { ProductItemComponent } from '@/modules/components';
import { v4 as uuidv4 } from 'uuid';

type SpecialityComponentProps = {
  products: Product[];
};

export const SpecialityComponent = ({ products }: SpecialityComponentProps) => {
  const { language } = useTranslation();
  const { orders, setOrders, orderEnable, categories } = useInteractionState();

  const [foodCategories, setFoodCategories] = useState<Category[]>(categories);
  const [foods, setFoods] = useState<Product[]>(products);

  const filterFood = (id: string) => {
    const updateCategories = map(foodCategories, (it: Category) => {
      it.selected = it.id === id;
      return it;
    });

    const updateFoods = filter(products, (it: Product) => {
      const foodCategories = map(it.category, (c) => c.id);
      return foodCategories.indexOf(id) > -1;
    });

    setFoodCategories([...updateCategories]);
    setFoods([...updateFoods]);
  };

  const addProductItemToCart = (item: Product) => {
    let currentOrders = [...(orders ?? [])];
    const found = find(
      currentOrders,
      (it: Order) => it.reference === item.reference_id
    );
    if (found) {
      found.quantity += 1;
    } else {
      const order: Order = {
        id: uuidv4(),
        reference: item.reference_id,
        nameDe: item.name_de,
        nameEn: item.name_en,
        nameZn: item.name_zn,
        descriptionDe: item.description_de,
        descriptionEn: item.description_en,
        descriptionZn: item.description_zn,
        price: item.price,
        quantity: 1,
      };
      currentOrders = [...currentOrders, order];
    }
    setOrders?.([...currentOrders]);
  };

  const ProductItems = () => {
    const productItems = map(foods, (it: Product) => {
      const selected = some(
        orders,
        (order) => order.reference === it.reference_id
      );
      return (
        <div
          className="item"
          key={it.id}
          //style is to fix android galaxy mobile
          style={{ position: 'relative', display: it.show ? '' : 'none' }}
        >
          <ProductItemComponent
            product={it}
            language={language}
            onClick={addProductItemToCart}
            enable={orderEnable}
            selected={selected}
          />
        </div>
      );
    });
    return <div className="portfolio">{productItems}</div>;
  };

  const categoryItems = chain(foodCategories)
    .filter((it: Category) => it.show)
    .map((it: Category) => (
      <li
        key={it.id}
        className={it.selected ? 'active' : ''}
        onClick={() => filterFood(it.id)}
      >
        <FormattedMessage id={'app.menu.' + it.name} />
      </li>
    ))
    .value();

  return (
    <section id="speciality" className="description_content">
      <div className="text-content container">
        <div className="container">
          <div className="row">
            <div>
              <ul className="filter-list">{categoryItems}</ul>
              <ProductItems />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
